/**
 * @prop --size: Icon size
 * @prop --color: Icon color
 *
 * @prop --stzh-icon-size: **Global**: Default icon size. [See available icon sizes here](/docs/tokens-icons--docs#sizes).
 * @prop --stzh-icon-color: **Global**: Icon color
 * @prop --stzh-icon-vertical-align: **Global**: Icon vertical alignment
 */

:host {
  --size: #{iconSize()};
  --color: #{$iconColor};
  --vertical-align: #{$iconVerticalAlign};

  display: inline-flex;
  justify-content: center;
  align-items: center;
  color: var(--color);
  vertical-align: var(--vertical-align);
  width: var(--size);
  height: var(--size);

  @media print {
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
}

.stzh-icon {
  display: none;

  &__svg {
    width: var(--size);
    height: var(--size);
  }
}
